/**
 *
 * Email Integration
 *
 */

import React, { memo } from 'react';

import { useIntegrationsContext } from 'containers/Setup/Integrations/context/context';

import { CreateEmailGroup } from './CreateEmailGroup';
import { EditEmailGroup } from './EditEmailGroup';
import { EmailTable } from './EmailTable';

interface Props {}

export const EmailGroup = memo((props: Props) => {
  const { actionType, isOpen } = useIntegrationsContext();

  return isOpen ? (
    actionType === 'Add' ? (
      <CreateEmailGroup />
    ) : (
      <EditEmailGroup />
    )
  ) : (
    <EmailTable />
  );
});
